const trackPageview = ({page}) => {
  if (window && window.ga) {
    const args = [`gtm3.send`, `pageview`, page].filter((i) => i !== void 0);
    window.ga.apply(null, args);
  }
};

export default trackPageview;
